import { gql } from '@apollo/client';

/**
 * Tenant fragment with all commonly used fields including type and features
 */
const TENANT_FIELDS = gql`
  fragment TenantFields on Tenant {
    id
    name
    slug
    description
    contactEmail
    contactName
    isActive
    type
    features
    isMandatory
    billingStatus
    createdAt
    updatedAt
    invoiceHeader {
      logoUrl
    }
  }
`;

export const GET_MY_TENANTS = gql`
  ${TENANT_FIELDS}
  query GetMyTenants {
    myTenants {
      id
      userId
      tenantId
      role
      permissions
      isActive
      invitedBy
      invitedAt
      lastAccessedAt
      tenant {
        ...TenantFields
      }
      createdAt
      updatedAt
    }
  }
`;

export const SELECT_TENANT_MUTATION = gql`
  ${TENANT_FIELDS}
  mutation SelectTenant($input: SelectTenantInput!) {
    selectTenant(input: $input) {
      ...TenantFields
    }
  }
`;

export const GET_TENANT = gql`
  ${TENANT_FIELDS}
  query GetTenant($id: ID!) {
    tenant(id: $id) {
      ...TenantFields
    }
  }
`;

export const GET_TENANT_BY_SLUG = gql`
  ${TENANT_FIELDS}
  query GetTenantBySlug($slug: String!) {
    tenantBySlug(slug: $slug) {
      ...TenantFields
    }
  }
`;

/**
 * Set the grantable features (e.g. CRM) for a client tenant. Platform-admin
 * only — used by the Master client-management surface. `features` is the
 * desired state of the grantable subset; structural features are preserved
 * server-side.
 */
export const SET_TENANT_FEATURES = gql`
  ${TENANT_FIELDS}
  mutation SetTenantFeatures($tenantId: ID!, $features: [TenantFeature!]!) {
    setTenantFeatures(tenantId: $tenantId, features: $features) {
      ...TenantFields
    }
  }
`;

export const GET_INVITATION_BY_TOKEN = gql`
  query GetInvitationByToken($token: String!) {
    invitationByToken(token: $token) {
      id
      email
      role
      isActive
      invitedAt
      invitationAcceptedAt
      tenant {
        id
        name
        slug
        description
        isActive
        type
        features
        isMandatory
      }
    }
  }
`;

export const ACCEPT_INVITATION_MUTATION = gql`
  mutation AcceptInvitation($token: String!) {
    acceptInvitation(token: $token) {
      id
      userId
      tenantId
      role
      isActive
      invitationAcceptedAt
      tenant {
        id
        name
        slug
        description
        isActive
        type
        features
        isMandatory
      }
    }
  }
`;
